module.exports = __webpack_public_path__ + "static/media/Fairways_West_Lot_Map.00a0926c.pdf";